module.exports = __webpack_public_path__ + "media/site/images/technologies/spree-icon-9c47ffc72511c521fbf5f964a7c4d153.svg";